import { GenericSuspense, useUrlParamsValueToString, RightSidebar, Box, Menu } from "@bsm/component";
import { useNavigate, Outlet } from "react-router-dom";
import { useHolidayViewerMenu } from "../hooks/useViewerMenu";

export const HolidayGroupViewerContainer = () => {

    const tab = location.pathname.split("/").at(-1);
    const holidayViewerMenuItems = useHolidayViewerMenu()
    const urlParamsValueString = useUrlParamsValueToString()
    const navigate = useNavigate()

    const closeViewer = () => {
        navigate(`..?${urlParamsValueString}`)
    }

    return (
        <RightSidebar className={`right-sidebar-absolute p-0`} onClose={closeViewer}>
            <Box title="Holiday Groups" className="h-[max-content] overflow-auto min-h-[100%] flex flex-col gap-[36px]">
                <div className="flex flex-col justify-center gap-4">
                    <Menu
                        items={holidayViewerMenuItems}
                        type="HORIZONTAL"
                        className="menu-tabs"
                        activeFn={(menu) => menu.ke === tab}
                    />

                    <GenericSuspense>
                        <Outlet />
                    </GenericSuspense>
                </div>
            </Box>
        </RightSidebar>
    );
};